import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3.563 5.047a3.266 3.266 0 1 1 6.53 0 3.266 3.266 0 0 1-6.53 0m7.718 1.781a2.673 2.673 0 0 1 4.561-1.89 2.673 2.673 0 1 1-4.56 1.89M1.188 15.141a5.64 5.64 0 1 1 11.28 0v.096a.6.6 0 0 1-.287.499 10.35 10.35 0 0 1-5.353 1.483c-1.957 0-3.789-.542-5.352-1.483a.6.6 0 0 1-.288-.499zm12.468.002v.114a1.8 1.8 0 0 1-.185.76 8 8 0 0 0 4.006-.8.59.59 0 0 0 .332-.509 3.86 3.86 0 0 0-5.507-3.65 6.8 6.8 0 0 1 1.354 4.083z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }